import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AttachSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AttachSVG;
